import React from 'react';
import { createRoot } from 'react-dom/client';
import './jquery-global';
import 'jquery-migrate';
import './tracking-scripts';
import Orchestrator from './Orchestrator';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <Orchestrator />
    </React.StrictMode>
  );
}
